import React from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import _ from 'lodash'

import ManageVehicles from '../../smart/menuComponentsContainer/ManageVehicles'
import CompanyContainer from '../../smart/menuComponentsContainer/CompanyContainer'

const HomeAccess = (props) => {

    const { user, location } = props;
    const userRole = user.roles[0];
    const user_permissions = user.permissions || [];

    if (!user || !['partner', 'custom_partner', 'partner_view'].includes(userRole)) {
        browserHistory.push('/login');
    } else {
        if ((userRole === 'custom_partner') && !_.find(user_permissions, { 'perm_category_id': 4, 'a_view': true })) {
            return <CompanyContainer />
        } else {
            return <ManageVehicles />
        }
    }
}

export default connect(
    state => ({
        user: state.user.user,
    }),
)(HomeAccess);
